export const affiliateStateKey = 'affiliate';
export const affiliateInfoStateKey = 'info';
export const affiliateSaleStateKey = 'affiliate-sales';
export const affiliatePayoutStateKey = 'affiliate-payouts';
